import Model from "../Model";

export interface TPortalApplicant {
  id: number;
  lastName: string;
  firstName: string;
  institutionName: string;
  positionTypeName: string;
  reportingPeriodApplicantId: number;
}

export interface IPortalApplicant extends TPortalApplicant {}

const PortalApplicant = Model(
  (model: TPortalApplicant): IPortalApplicant => {
    const _portalApplicant: TPortalApplicant = Object.assign({}, model);

    return {
      get id() {
        return _portalApplicant.id;
      },
      set id(value) {
        _portalApplicant.id = value;
      },
      get lastName() {
        return _portalApplicant.lastName;
      },
      set lastName(value) {
        _portalApplicant.lastName = value;
      },
      get firstName() {
        return _portalApplicant.firstName;
      },
      set firstName(value) {
        _portalApplicant.firstName = value;
      },
      get institutionName() {
        return _portalApplicant.institutionName;
      },
      set institutionName(value) {
        _portalApplicant.institutionName = value;
      },
      get positionTypeName() {
        return _portalApplicant.positionTypeName;
      },
      set positionTypeName(value) {
        _portalApplicant.positionTypeName = value;
      },
      get reportingPeriodApplicantId() {
        return _portalApplicant.reportingPeriodApplicantId;
      },
      set reportingPeriodApplicantId(value) {
        _portalApplicant.reportingPeriodApplicantId = value;
      }
    };
  }
);

export default PortalApplicant;
